import React from 'react'
import ReactDOM from 'react-dom/client'
import TypingApp from './Features/TypingApp.jsx';
import './CSS/index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
    <TypingApp />
)
